module.exports = __webpack_public_path__ + "media/newstyle/images/info3-2337f5522ba8b90204639788f2d29ce0.jpg";